import { useRef, useCallback, useEffect } from 'react';
import {
  URLSearchParamsInit,
  SetURLSearchParams,
  useSearchParams,
  createSearchParams,
} from 'react-router-dom';

const unionParams = (
  params1: URLSearchParams,
  params2: URLSearchParams,
): URLSearchParams => {
  const combinedParams = new URLSearchParams(params1);
  for (const [key, value] of params2.entries()) {
    if (combinedParams.getAll(key).includes(value)) continue;
    combinedParams.append(key, value);
  }
  return combinedParams;
};

export default function useSearchParamsWithSetInit(
  defaultInit?: URLSearchParamsInit,
): [URLSearchParams, SetURLSearchParams] {
  const [searchParams, setSearchParams] = useSearchParams();
  const count = useRef(0);

  const setSearchParamsMiddleware: SetURLSearchParams = useCallback(
    params => {
      count.current++;
      setSearchParams(params);
    },
    [setSearchParams],
  );
  const defaultSearchParams = useRef(createSearchParams(defaultInit));

  const size = searchParams.toString().length;
  useEffect(() => {
    if (!count.current && !size)
      setSearchParamsMiddleware(
        unionParams(defaultSearchParams.current, searchParams),
      );
  }, [setSearchParamsMiddleware, searchParams, size]);

  return [searchParams, setSearchParamsMiddleware];
}
